<template>
  <div :class="noBorder ? 'mb-0' : 'block-list mb-3'">
    <div :class="dangerMessage ? 'border border-danger p-3' : ''">
      <div>
        <div v-if="dangerMessage" class="mb-3 font-weight-bold text-danger">
          {{ dangerMessage }}
        </div>
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex flex-wrap">
            <Logo v-if="logo" class="mr-2" :logo="logo" :size="56" />
            <div class="bl-title font-weight-bold mr-3 mb-2" :class="logo ? 'mt-1' : ''">
              {{ title }}
            </div>
            <div v-if="tag" class="mb-2 mt-1">
              <Tag :variant="tag[0].variant" :content="tag[0].title" />
            </div>
          </div>
          <div v-if="actions" class="mb-2"><ActionIcons :actions="actions" /></div>
        </div>
      </div>
      <ul v-if="list" class="list-unstyled" :class="noBorder ? 'mb-0' : 'mb-2'">
        <li v-for="(item, i) in list" :key="i">{{ item.item }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import ActionIcons from "@/components/display/ActionIcons";
import Logo from "@/components/display/Logo";
import Tag from "@/components/display/Tag";
export default {
  name: "CardBlockList",
  components: { ActionIcons, Logo, Tag },
  props: {
    dangerMessage: String,
    logo: String,
    title: {
      type: String,
      required: true,
    },
    tag: Array,
    list: Array,
    actions: {
      type: Array,
      default: () => [],
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.block-list {
  border-bottom-width: 1px;
  border-bottom-style: solid;
}
.bl-title {
  font-weight: bold;
  letter-spacing: 0.12px;
  font-size: 1rem;
}
</style>
